// extracted by mini-css-extract-plugin
export var errorIcon = "_mv-1";
export var nameLogo = "_mv-0";